import React, { useEffect } from 'react'

import { Box, Stack, useTheme } from '@mui/material'

import { EmptyAccountData } from '../../components/EmptyAccountData'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

import { CashFlowService } from './CashFlowService'
import { fetchCashFlowBalance } from './CashFlowSlice'
import { CashFlowSummaryWidgets } from './CashFlowSummaryWidgets'
import { CashFlowTable } from './CashFlowTable'
import { CashFlowStatsResponseType } from './types'

const CashFlowPage: React.FC = () => {
  const { spacing } = useTheme()
  const dispatch = useAppDispatch()
  const { userAccounts, currentAccount } = useAppSelector(({ userAccounts }) => userAccounts)
  const { period } = useAppSelector(({ userAccounts }) => userAccounts)
  const { balance, balanceLoading } = useAppSelector((state) => state.cashFlow)
  const [stats, setStats] = React.useState<CashFlowStatsResponseType>({
    netProfit: 0,
    deposits: 0,
    withdrawals: 0,
    credits: 0,
  })

  useEffect(() => {
    if (currentAccount?.id) {
      dispatch(fetchCashFlowBalance({ account: currentAccount.id }))
      CashFlowService.getCashFlowStats({ account: currentAccount.id, period }).then(({ data }) =>
        setStats(data),
      )
    }
  }, [currentAccount?.id, dispatch, period])

  return Boolean(userAccounts.length) ? (
    <Stack p={spacing(2)} direction="column" flex={1} height="100%">
      <CashFlowSummaryWidgets
        currency={currentAccount?.currency}
        balance={balance}
        balanceLoading={balanceLoading}
        stats={stats}
      />
      <CashFlowTable />
    </Stack>
  ) : (
    <Box display="flex" flexDirection="column" height="100%" flex={1}>
      <EmptyAccountData />
    </Box>
  )
}

export default CashFlowPage
